import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTenantIdFromProject } from "@vertesia/common";
import { Tabs, TabsBar, TabsPanel, VTooltip } from "@vertesia/ui/core";
import { Env } from "@vertesia/ui/env";
import { useUserSession } from "@vertesia/ui/session";
// Package version is now passed as prop from the consuming application
import { Check, CopyIcon } from "lucide-react";
import { useState } from "react";
import { useUITranslation } from '../../i18n/index.js';
export function InfoItems({ title, value }) {
    function copyToClipboard(value) {
        navigator.clipboard.writeText(value);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    }
    const [isCopied, setIsCopied] = useState(false);
    return (_jsxs("div", { className: "w-full flex justify-between items-center mb-1", children: [_jsxs("div", { className: "flex flex-col w-[calc(100%-3rem)]", children: [_jsx("div", { className: 'text-sm px-2 dark:text-slate-200', children: title }), _jsx(VTooltip, { description: value, size: "xs", placement: "left", children: _jsxs("div", { className: 'text-xs truncate text-muted w-full text-left px-2', children: [value, " "] }) })] }), isCopied ?
                _jsx(Check, { className: "size-4 cursor-pointer text-success" })
                :
                    _jsx(CopyIcon, { className: "size-4 cursor-pointer text-gray-400 dark:text-slate-400", onClick: () => copyToClipboard(value) })] }));
}
export default function InfoList() {
    const { t } = useUITranslation();
    const session = useUserSession();
    const { account, project, client, authToken } = session;
    const server = new URL(client.baseUrl).hostname;
    const store = new URL(client.store.baseUrl).hostname;
    const tenantId = project ? getTenantIdFromProject(project) : '';
    const tabs = [
        {
            name: 'user',
            label: t('user.user'),
            content: _jsxs("div", { className: "space-y-1 p-2", children: [_jsx(InfoItems, { title: t('user.organizationId'), value: account?.id ?? t('user.unknown') }), _jsx(InfoItems, { title: t('user.projectId'), value: project?.id ?? t('user.unknown') }), _jsx(InfoItems, { title: t('user.userId'), value: authToken?.sub ?? t('user.unknown') }), _jsx(InfoItems, { title: t('user.organizationRoles'), value: authToken?.account_roles?.join(',') ?? t('user.unknown') }), _jsx(InfoItems, { title: t('user.projectRoles'), value: authToken?.project_roles?.join(',') ?? t('user.unknown') })] })
        },
        {
            name: 'environment',
            label: t('user.environment'),
            content: _jsxs("div", { className: "space-y-1 p-2", children: [_jsx(InfoItems, { title: t('user.tenantId'), value: tenantId }), _jsx(InfoItems, { title: t('user.environment'), value: Env.type }), _jsx(InfoItems, { title: t('user.server'), value: server }), _jsx(InfoItems, { title: t('user.store'), value: store }), _jsx(InfoItems, { title: t('user.appVersion'), value: Env.version }), _jsx(InfoItems, { title: t('user.sdkVersion'), value: Env.sdkVersion || t('user.unknown') })] })
        }
    ];
    return (_jsx("div", { className: "w-full", children: _jsxs(Tabs, { defaultValue: "user", tabs: tabs, fullWidth: true, updateHash: false, children: [_jsx(TabsBar, {}), _jsx(TabsPanel, {})] }) }));
}
//# sourceMappingURL=UserInfo.js.map